<template>
    <div class="gs:grid">
        <filters-component
            @newResults="updateResults"
            @orderEdit="updateOrders"
            @filters="updateFilters"
            :selectOrder="ordersBy"
            :inventory-years="inventoryYears"
            ref="filters"
            class="lg:col-4 text-center"
            :ad="ad"
        ></filters-component>

        <div class="backdrop"></div>

        <div class="lg:col-12 mt-12 md:mt-2">
            <div class="block info-ad mb-4 md:mb-0">
                <filter-car-type-component @change="updateFilter" :hidden="false" ref="car_type"></filter-car-type-component>
            </div>
            <div class="mb-4 md:hidden flex justify-content-between">
                <a @click="openInfo()" class="underline weight-500">
                    <span v-show="!isOpen">
                        <i class="fas fa-chevron-down"></i>
                        Más info
                    </span>
                    <span v-show="isOpen">
                        <i class="fas fa-chevron-up"></i>
                        Leer menos
                    </span>
                </a>
                <h4 class="weight-600">Resultado: {{ countProducts }} Autos</h4>
            </div>
            <div class="hidden md:flex justify-content-end">
                <h3 class="weight-600">Resultado: {{ countProducts }} Autos</h3>
            </div>

            <div v-if="promotionImage && promotionSlogan" class="flex justify-content-center hot-deal-2">
                <img :src="promotionImage" class="img-bd" style="padding:3px">
                <div class="flex tx-18 ff-montserrat-bold text-justify" style="margin: 16px 5px;">
                    <span>{{ promotionSlogan }}
                        <span style="font-size: 0.87rem;"> *Solo autos participantes</span>
                    </span>
                </div>
            </div>

            <div class="box box--white flex justify-content-between p-3 mb-4">
                <tags-component :filters="filters"></tags-component>
                <!-- <orderby-component
                    v-if="!!ordersBy"
                    @orderEdit="updateOrders"
                    :selectOrder="ordersBy"
                    ref="catalogOrder"
                    class="hidden lg:block w-fit"
                    :type="'large'"
                ></orderby-component> -->
            </div>
            <results-cars-component
                v-if="!!results.products"
                @showSignUpModal="showSignUpModal()"
                @newResults="updateResults"
                :vehicles="results.products"
                :page="results.currentPage"
                :total="results.lastPage"
                :total-products="countProducts"
                :total-items="countItems"
                :likes="likes"
            ></results-cars-component>
        </div>
        <div v-if="isAuthModalVisible" class="auth-modal">
            <div>
                <a class="close-auth-modal" @click="isAuthModalVisible = !isAuthModalVisible">&times;</a>
            </div>
            <div class="auth-modal-body">
                <h3>Selecciona una opción para empezar a guardar autos</h3>
                <button class="login-button" @click="isSignInModalVisible = !isSignInModalVisible">Ingresar</button>
                <button class="signup-button" @click="closeAuthAndOpenSignUp">Crear cuenta</button>
                <a href="#" @click="isAuthModalVisible = !isAuthModalVisible">Registrarme más tarde</a>
            </div>
        </div>
        <div v-if="isSignUpModalVisible" class="auth-modal">
            <div>
                <a class="close-auth-modal" @click="isSignUpModalVisible = !isSignUpModalVisible">&times;</a>
            </div>
            <div v-if="isSignUpModalFormVisible" class="auth-modal-body signup-modal-body">
                <h3>Crear cuenta</h3>
                <form class="tx-white" @submit.prevent="signUpUser" autocomplete="off">
                    <div>
                        <label for="full_name">Nombre completo</label>
                        <input id="full_name" type="text"
                        :class="{'redish-input': signUpFormErrors.full_name}"
                        v-model="signUpForm.full_name">
                    </div>
                    <div>
                        <div style="display: flex; padding-bottom: 5px; align-items: center;">
                            <label for="cellphone" style="display: inline-block; margin-right: 5px;">Celular</label>
                            <img src="/images/whatsapp-icon.png" alt="" style="width: 20px">
                        </div>
                        <the-mask id="cellphone" type="tel"
                            :masked="false"
                            :class="{'redish-input': signUpFormErrors.cellphone}"
                            mask="##-##-##-##-##"
                            v-model="signUpForm.cellphone"
                            autocomplete="off" />
                        <small v-if="!signUpFormErrors.cellphone">Enviaremos un código de verificación</small>
                        <small v-else-if="signUpFormErrors.cellphone[0] == 'No whatsapp Account'" style="color: #dc3545">Ingresa un número con whatsapp</small>
                        <small v-else="signUpFormErrors.cellphone[0]" style="color: #dc3545">{{ signUpFormErrors.cellphone[0] }}</small>
                    </div>
                    <div>
                        <label for="password">Contraseña</label>
                        <input id="password"
                        type="password"
                        :class="{'redish-input': signUpFormErrors.password}"
                        autocomplete="off"
                        v-model="signUpForm.password">
                        <small>Min 8 caracteres, una letra mayúscula, una mínuscula, un número y una caracter especial (._Q$#!)</small>
                    </div>
                    <button>Crear cuenta</button>
                </form>
            </div>
            <div v-else class="auth-modal-body whatsapp-validation-modal-body">
                <h3>Estamos creando tu cuenta</h3>
                <img src="/images/tube-spinner.svg" style="width: 50px;" alt="">
            </div>
        </div>
        <div v-if="isCodeValidationModalVisible" class="auth-modal">
            <div>
                <a class="close-auth-modal" @click="isCodeValidationModalVisible = !isCodeValidationModalVisible">&times;</a>
            </div>
            <div v-if="isCodeValidationModalFormVisible" class="auth-modal-body whatsapp-validation-modal-body">
                <h3>Ingresa el código de verificación que te enviamos por
                    <strong>Whatsapp</strong>
                    <img src="/images/whatsapp-icon.png" alt="" style="width: 20px">
                </h3>
                <form class="tx-white" @submit.prevent="validateWhatsappCode" autocomplete="off">
                    <div class="whatsapp-code-container">
                        <div class="vcode-input">
                            <the-mask  mask="#" type="text" maxlength="1" v-model="validationCodeForm.first_input"/>
                        </div>
                        <div class="vcode-input">
                            <the-mask  mask="#" type="text" maxlength="1" v-model="validationCodeForm.second_input"/>
                        </div>
                        <div class="vcode-input">
                            <the-mask  mask="#" type="text" maxlength="1" v-model="validationCodeForm.third_input"/>
                        </div>
                        <div class="vcode-input">
                            <the-mask  mask="#" type="text" maxlength="1" v-model="validationCodeForm.forth_input"/>
                        </div>
                        <div class="vcode-input">
                            <the-mask  mask="#" type="text" maxlength="1" v-model="validationCodeForm.fifth_input"/>
                        </div>
                        <div class="vcode-input">
                            <the-mask  mask="#" type="text" maxlength="1" v-model="validationCodeForm.sixth_input"/>
                        </div>
                    </div>
                    <small v-if="validationCodeError" style="color: #dc3545">El código es incorrecto, verificalo.</small>
                    <button>Verificar</button>
                </form>
            </div>
            <div v-else class="auth-modal-body whatsapp-validation-modal-body">
                <h3>¡Todo listo!</h3>
                <img src="/images/success-check.png" style="width: 50px;" alt="">
                <button @click="isCodeValidationModalVisible = !isCodeValidationModalVisible"
                style="margin-top: 0px; background: lightgray;">Seguir viendo autos</button>
            </div>
        </div>
        <div  v-if="isSignInModalVisible" class="auth-modal">
            <div>
                <a class="close-auth-modal" @click="isSignInModalVisible = !isSignInModalVisible">&times;</a>
            </div>
            <div class="auth-modal-body signup-modal-body">
                <template v-if="!signInIsLoadling">
                    <h3>Ingresar</h3>
                    <form class="tx-white" @submit.prevent="signInUser" autocomplete="off">
                        <div>
                            <div style="display: flex; padding-bottom: 5px; align-items: center;">
                                <label for="cellphone" style="display: inline-block; margin-right: 5px;">Celular</label>
                            </div>
                            <the-mask id="cellphone" type="tel"
                                :masked="false"
                                mask="##-##-##-##-##"
                                v-model="signInForm.cellphone"
                                autocomplete="off" />
                            <small v-if="signInFormErrors.cellphone" style="color: #dc3545">Este celular no está asociado a una cuenta, verifica la información</small>
                        </div>
                        <div>
                            <label for="password">Contraseña</label>
                            <input id="password"
                            type="password"
                            autocomplete="off"
                            v-model="signInForm.password">
                            <small v-if="signInFormErrors.password" style="color: #dc3545">La contraseña es inválida, revisala y vuelve a intentar.</small>
                        </div>
                        <button style="margin: 40px auto">Ingresar</button>
                        <a href="" style="text-decoration: underline; font-size: .8rem; margin: 0 auto; display: block;"
                        @click.prevent="sendResetPasswordLink">Recuperar contraseña</a>
                    </form>
                </template>
                <template v-else>
                    <img src="/images/tube-spinner.svg" style="width: 50px;" alt="">
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import ResultsCarsComponent from "./ResultsCarsComponent.vue";
import FiltersComponent from "./FiltersComponent.vue";
import OrderbyComponent from "./OrderbyComponent.vue";
import TagsComponent from "./TagsComponent.vue";
import metadataService from '../../../../services/metadataService';
import FilterCarTypeComponent from './partials/filters/FilterCarTypeComponent.vue';

export default {
    props: {
        lastPage: Number,
        currentPage: Number,
        products: Array,
        likes: Array,
        inventoryYears: {
            type: Array,
            default: []
        },
        totalProducts: {
            type: Number,
            default: 0
        },
        ad: {
            type: Object,
        }
    },

    data: () => ({
        resultsContent: {
            products: null,
            lastPage: null,
            currentPage: null
        },
        countProducts: 0,
        ordersBy: 1,
        filters: null,
        isOpen: false,
        promotionSlogan: null,
        promotionImage: null,
        countItems: 0,
        statesNames: '',
        brandsNames: '',
        isAuthModalVisible: false,
        isSignUpModalVisible: false,
        isCodeValidationModalVisible: false,
        isCodeValidationModalFormVisible: false,
        isSignUpModalFormVisible: true,
        isSignInModalVisible: false,
        signInIsLoadling: false,
        signUpForm: {
            full_name: '',
            cellphone: '',
            password: ''
        },
        signInForm: {
            cellphone: '',
            password: ''
        },
        validationCodeForm: {
            first_input: '',
            second_input: '',
            third_input: '',
            forth_input: '',
            fifth_input: '',
            sixth_input: '',
        },
        signUpFormErrors: {
            full_name: null,
            cellphone: null,
            password: null
        },
        signInFormErrors: {
            cellphone: null,
            password: null
        },
        validationCodeError: false,
        swiperOptionTop: {
            lazy: true,
            slidesPerView: 1,
            spaceBetween: 8,
            loop: true,
            // loopFillGroupWithBlank: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            breakpoints: {
                320: {
                    slidesPerView: 2
                },
                375: {
                    slidesPerView: 3,
                    spaceBetween: 6
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 12
                },
                1280: {
                    slidesPerView: 6,
                    spaceBetween: 12
                }
            }
        }
    }),

    components: {
        "results-cars-component": ResultsCarsComponent,
        "filters-component": FiltersComponent,
        "orderby-component": OrderbyComponent,
        "tags-component": TagsComponent,
        'filter-car-type-component': FilterCarTypeComponent,
        "swiper": Swiper,
        "swiper-slide": SwiperSlide
    },

    beforeMount() {
        this.results = {
            products: this.products,
            lastPage: this.lastPage,
            currentPage: this.currentPage
        };
    },
    computed: {
        results: {
            get: function() {
                return this.resultsContent;
            },
            set: function(values) {
                this.resultsContent = values;
            }
        }
    },

    methods: {
        closeAuthAndOpenSignUp() {
            this.isAuthModalVisible = !this.isAuthModalVisible
            this.isSignUpModalVisible = !this.isSignUpModalVisible
        },
        async validateWhatsappCode() {
            const code = this.validationCodeForm.first_input +
            this.validationCodeForm.second_input +
            this.validationCodeForm.third_input +
            this.validationCodeForm.forth_input +
            this.validationCodeForm.fifth_input +
            this.validationCodeForm.sixth_input;

            const cellphone = localStorage.getItem('signup_cellphone')

            try {
                await axios.post('/auth/validate', {
                    cellphone: cellphone,
                    code: code
                })
                this.isCodeValidationModalFormVisible = false
                this.validationCodeError = false
            } catch (error) {
                console.error(error);
                if(error.response.status == 400)
                this.validationCodeError = true
            }
        },
        showSignUpModal() {
            console.log('showSignUpModal');
            this.isAuthModalVisible = !this.isAuthModalVisible
        },
        async signUpUser() {
            this.isSignUpModalFormVisible = !this.isSignUpModalFormVisible
            try {
                await axios.post('/auth/signup', this.signUpForm)
                localStorage.setItem('signup_cellphone', this.signUpForm.cellphone)

                this.isSignUpModalVisible = false
                this.isCodeValidationModalVisible = true
                this.isCodeValidationModalFormVisible = true
                this.isSignUpModalFormVisible = !this.isSignUpModalFormVisible
            } catch (error) {
                this.isSignUpModalFormVisible = !this.isSignUpModalFormVisible
                console.log(error.response);
                this.signUpFormErrors = error.response.data.errors
            }
        },
        async signInUser() {
            this.isSignUpModalFormVisible = !this.isSignUpModalFormVisible
            try {
                this.signInIsLoadling = true
                await axios.post('/auth/login', this.signInForm)
                this.isAuthModalVisible = false
                // this.isSignInModalVisible = false

                var swal = this.$swal
                setTimeout(function() {
                    swal({
                        icon: 'success',
                        title: 'Ya estás logueado',
                        text: '',
                    })  
                }, 1000);


                setTimeout(() => {
                    window.location.href = '/perfil'
                }, 3000)

            } catch (error) {
                console.log(error.response);
                this.signInFormErrors = error.response.data.errors
                this.signInIsLoadling = false
            }
        },
        async sendResetPasswordLink() {
            console.log(this.signInForm.cellphone);
            if(!this.signInForm.cellphone || this.signInForm.cellphone.length < 10) alert('Ingresa el número de teléfono')
            try {
                await axios.post('/auth/send-reset-link', this.signInForm)
                this.isAuthModalVisible = false
                this.isSignInModalVisible = false
            } catch (error) {
                console.log(error.response);
                this.signInFormErrors = error.response.data.errors
            }
        },
        updateResults(values) {
            this.results = {
                products: values.products,
                lastPage: values.lastPage,
                currentPage: values.currentPage,
            };

            this.countProducts = this.sumNewVehiclesAvailables(values.products);
            this.countItems = values.total;
        },
        updateOrders(values) {
            this.ordersBy = parseInt(values);
        },
        updateFilters(values) {
            this.filters = values;
            this.setMetadata()
        },
        updateFilter(filter, value) {
            this.filters[filter] = value
        },
        openInfo() {
            this.isOpen = !this.isOpen;
        },
        sumNewVehiclesAvailables (vehicles) {
            let total = 0
            vehicles.forEach(element => {
                total += element.available
            });
            return total;
        },
        async getPromotions() {
            const { data } = await axios.get(`${process.env.MIX_API_SUBASTALO_URL}/api/marketplace/get-promotions-by-type/new`)
            if (data.length === 1) {
                this.promotionSlogan = data[0].slogan
                this.promotionImage = data[0].image
            } else {
                this.promotionSlogan = null
                this.promotionImage = null
            }
        },
        getDealershipsStates() {
            if (!this.$store.state.catalogNewVehicle.states.length) return;
            let statesToInclude = this.filters.states; // Array de estados a incluir
            let statesNameArray = this.$store.state.catalogNewVehicle.states.filter(item => {
                return statesToInclude.includes(item.id.toString()) || statesToInclude.includes(item.id); // Verifica si el nombre del estado está en el array statesToInclude
            }).map(item => item.name);

            let stringStates = statesNameArray.join(", ");
            this.statesNames = stringStates;
        },
        getBrands() {
            if (!this.$store.state.catalogNewVehicle.brands.length) return;

            let brandsToInclude = this.filters.brands; // Array de estados a incluir

            let brandsNamesArray = this.$store.state.catalogNewVehicle.brands.filter(item => {
                return brandsToInclude.includes(item.id.toString()) || brandsToInclude.includes(item.id); // Verifica si el nombre del estado está en el array statesToInclude
            }).map(item => item.title);

            let stringBrands = brandsNamesArray.join(", ");
            this.brandsNames = stringBrands;
        },
        setMetadata() {
            this.getDealershipsStates();
            this.getBrands();
            metadataService.createMetaDescription(`Autos ${this.brandsNames} nuevos en venta ${this.statesNames ? 'en' : ''} ${this.statesNames} | AutoDeal`,
            `Encuentra los mejores autos nuevos ${this.brandsNames}${this.statesNames ? 'en' : ''} ${this.statesNames}, consulta en mas de 2000 anuncios de autos certificados en ${this.statesNames}`);
        },
    },
    async mounted() {
        await this.getPromotions();
    }
}
</script>
<style lang="css">
    @media (max-width: 542px) {
        .header__search__filters {
            width: 80%;
            right: none;
        }
        .header__filters {
            width: 20%;
            position: absolute;
            right: 0;
            top: 46px;
            background: #000000;
            padding: 8px 0 10px 12px;
            border-bottom: 1px solid #000000;

        }
        .mr-1 {
            margin-right: 0;
        }
    }
    .mr-2 {
        margin-right: 1rem;
    }
</style>

<style scoped>
.hot-deal-2{
    text-align: center;
    color: white;
    background-color: black;
    padding: 4px;
    border-radius: 5px;
    align-items: center;
}
.img-bd{
    max-width: 100px;
}
.img-bd-buendeal{
    max-width: 80px;
}

.auth-modal {
    width: 90%;
    position: absolute;
    background: #000000dd;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    z-index: 99;
}

@media screen and (min-width: 1024px) {
    .auth-modal {
        width: 300px;
    }
}

.auth-modal > div > .close-auth-modal {
    float: right;
    color: #fff;
    font-size: 2.2rem;
    margin-right: 7px;
}

.auth-modal > div.auth-modal-body {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    padding: 0 40px 40px 40px;
}

.auth-modal > .auth-modal-body > *:not(:last-child) {
    margin-bottom: 30px;
}

.auth-modal > div.auth-modal-body button {
    width: 150px;
    padding: 8px 0;
    border-radius: 5px;
    border: none;
    font-size: 0.8rem;
    font-weight: bold;
}

.auth-modal > div.auth-modal-body > .login-button  {
    background: #DBFE54;
}

.auth-modal > div.auth-modal-body > .signup-button {
    background: #fff;
}

.auth-modal > div.auth-modal-body > h3 {
    font-size: .9rem;
}

.auth-modal > div.auth-modal-body > h3,a {
    text-align: center;
    color: #fff;
    font-weight: bold;
}

.auth-modal > div.auth-modal-body > a {
    text-decoration: underline;
    font-size: .8rem;
}

.auth-modal-body > form input {
    border-radius: 5px;
    width: 100%;
}

.signup-modal-body > form > div:not(:last-child) {
    margin-bottom: 15px;
}

.signup-modal-body > form >  {
    font-weight: bold;
}

.signup-modal-body > form > div > label {
    font-size: .9rem;
    display: block;
    margin-bottom: 5px;
}

.signup-modal-body > form > div > small {
    font-size: .7rem;
}

.signup-modal-body > form > button {
    display: block;
    margin: 0 auto;
    background: #DBFE54;
}

.redish-input {
    border-color:#dc3545;
    box-shadow: 0 0 0 .2rem rgba(220,53,69,.25);
}

.whatsapp-validation-modal-body button {
    background: #DBFE54;
    display: block;
    margin: 0 auto;
    margin-top: 50px;
}

.whatsapp-code-container {
    display: flex;
}

.whatsapp-code-container > .vcode-input:not(:last-child) {
    margin-right: 10px;
}

.vcode-input {
  position: relative;
}

.vcode-input > input[type=text] {
  background: transparent;
  border: none;
  border-bottom: solid 1px #DBFE54;
  padding: 5px;
  transition: padding 0.4s;
  color: #fff;
  text-align: center;
  font-size: 1.4rem;
  border-radius: 0;
}

.vcode-input > input[type=text]:focus {
    box-shadow: none;
}

.vcode-input > input[type=text]:placeholder-shown + label {
  color: #aaa;
  font-size: 14px;
  left: 5px;
  top: 5px;
}
 </style>
